<template>
  <div>
    <jor_18bar />
    <v-container fluid>
      <base-material-card
        icon="mdi-clipboard-text"
        title="ข้อมูลประเภทสถานศึกษา"
        class="px-5 py-3"
      >
        <v-card class="mb-4 pa-2">
          <v-row>
            <v-col cols="12" md="8">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="ค้นหา ระบุคำ หรือ ส่วนข้อความเกี่ยวข้อง"
                single-line
                hide-details
                dense
                filled
                clearable
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-btn
                block
                large
                color="primary"
                @click="jor18Add"
              >
                <v-icon left>mdi-plus-circle-outline</v-icon>
                เพิ่มรายการ
              </v-btn>
            </v-col>

            <v-col cols="12" md="4">
              <v-autocomplete
                v-model="collegesSelect"
                :items="colleges"
                item-text="college_name"
                item-value="college_code"
                outlined
                dense
                label="ค้นหาวิทยาลัย"
                clearable
                @change="jor18sSearch"
              />

              <v-btn
                color="info"
                outlined
                block
                class="mb-2"
                @click="searchDirector"
              >
                <v-icon left>mdi-magnify</v-icon>
                ค้นหาตำแหน่งว่าง ผอ.
              </v-btn>

              <v-btn
                color="info"
                outlined
                block
                class="mb-2"
                @click="searchSecDirector"
              >
                <v-icon left>mdi-magnify</v-icon>
                ค้นหาตำแหน่งว่าง รอง ผอ.
              </v-btn>

              <v-btn
                color="info"
                outlined
                block
                @click="searchTeacher"
              >
                <v-icon left>mdi-magnify</v-icon>
                ค้นหาตำแหน่งว่าง ครู
              </v-btn>
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                v-model="idPositionSelect"
                outlined
                dense
                label="ค้นหาเลขที่ตำแหน่ง"
                clearable
                @keypress.enter="jor18sIDpostionSearch"
              />

              <v-btn
                block
                color="info"
                class="mb-2"
                :href="`#/admin/print_jor18_null/`"
                target="_blank"
              >
                <v-icon left>mdi-printer</v-icon>
                ส่งออกตำแหน่งว่าง ทั้งหมด
              </v-btn>

              <v-btn
                block
                color="info"
                class="mb-2"
                :href="`#/admin/print_jor18_teacherNull/`"
                target="_blank"
              >
                <v-icon left>mdi-printer</v-icon>
                ส่งออกตำแหน่งว่าง ครู(สำรวจ)
              </v-btn>

              <v-btn
                block
                color="info"
                :href="`#/admin/print_jor18_teacherMove/`"
                target="_blank"
              >
                <v-icon left>mdi-printer</v-icon>
                ส่งออกตำแหน่งว่าง ครู(สำรวจ ย้าย)
              </v-btn>
            </v-col>

            <v-col cols="12" md="4">
              <v-btn
                block
                color="primary"
                class="mb-2"
                @click="man_powerCSV"
              >
                <v-icon left>mdi-file-import</v-icon>
                นำเข้าข้อมูลอัตราสำรวจ
              </v-btn>

              <v-btn
                block
                color="warning"
                class="mb-2"
                @click="updatej18background"
              >
                <v-icon left>mdi-pencil</v-icon>
                ปรับปรุงอัตรากำลังรับย้ายครู
              </v-btn>

              <v-btn
                block
                color="primary"
                class="mb-2"
                @click="SearchNull"
              >
                <v-icon left>mdi-search-web</v-icon>
                ตำแหน่งว่าง
              </v-btn>

              <v-btn
                block
                color="info"
                class="mb-2"
                @click="clearSearch"
              >
                <v-icon left>mdi-broom</v-icon>
                ล้างการค้นหา
              </v-btn>

              <v-btn
                block
                color="error"
                @click="clearSurvey"
              >
                <v-icon left>mdi-delete-sweep</v-icon>
                ลบรายการสำรวจ
              </v-btn>
            </v-col>
          </v-row>
        </v-card>

        <v-data-table
          :headers="showHeaders"
          :items="jor18s"
          :search="search"
          :loading="loading"
          class="elevation-1"
        >
          <template v-slot:top>
            <v-select
              v-model="selectedHeaders"
              :items="headers"
              label="เลือกคอลัมน์ที่ต้องการแสดง"
              multiple
              outlined
              dense
              return-object
              class="ma-2"
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index < 6" small>
                  <span>{{ item.text }}</span>
                </v-chip>
                <span v-if="index === 6" class="grey--text caption">
                  (+{{ selectedHeaders.length - 6 }} คอลัมน์)
                </span>
              </template>
            </v-select>
          </template>

          <template v-slot:item.titles="{ item }">
            {{ item.titles }}{{ item.first_name }} {{ item.last_name }}
          </template>

          <template v-slot:item.actionSelect="{ item }">
            <v-chip v-if="hasIdCard(item)" outlined color="success">
              มีคนครอง
            </v-chip>
            <div v-else>
              <div v-if="item.id_no === editedItem.id_no">
                <v-btn icon color="error" @click="close">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-btn icon color="success" @click="save">
                  <v-icon>mdi-content-save</v-icon>
                </v-btn>
              </div>
              <div v-else>
                <v-btn icon color="primary" @click="editItem(item)">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
                <v-btn icon color="error" @click="deleteItem(item.id_no)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </div>
            </div>
          </template>

          <template v-slot:item.j18_reason="{ item }">
            <v-autocomplete
              v-if="item.id_no === editedItem.id_no"
              v-model="editedItem.j18_reason"
              :items="reasons"
              item-text="text"
              item-value="value"
              outlined
              dense
              label="เหตุผล"
            />
            <span v-else>{{ item.j18_reason }}</span>
          </template>

          <template v-slot:item.j18_collegereport="{ item }">
            <v-radio-group
              v-if="item.id_no === editedItem.id_no"
              v-model="editedItem.j18_collegereport"
              row
            >
              <v-radio value="1" label="สำรวจ" color="success" />
              <v-radio value="0" label="ไม่สำรวจ" color="warning" />
            </v-radio-group>
            <div v-else>
              <v-icon v-if="item.j18_collegereport === 1" color="success">
                mdi-check-circle
              </v-icon>
              <v-icon v-else color="grey">
                mdi-close-circle-outline
              </v-icon>
            </div>
          </template>

          <template v-slot:item.j18_reason_etc="{ item }">
            <v-text-field
              v-if="item.id_no === editedItem.id_no"
              v-model="editedItem.j18_reason_etc"
              outlined
              dense
              label="เหตุผลอื่น"
            />
            <span v-else>{{ item.j18_reason_etc }}</span>
          </template>

          <template v-slot:item.j18_background="{ item }">
            <v-text-field
              v-if="item.id_no === editedItem.id_no"
              v-model="editedItem.j18_background"
              outlined
              dense
              label="เหตุการณ์"
            />
            <span v-else>{{ item.j18_background }}</span>
          </template>

          <template v-slot:item.status_booking="{ item }">
            <v-chip 
              :color="item.status_booking ? 'warning' : 'success'" 
              dark 
              small
            >
              {{ item.status_booking || 'ว่าง' }}
            </v-chip>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-btn
              icon
              color="warning"
              @click="jor18Edit(item.id_position, item.positions)"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </template>

          <template v-slot:item.action_s="{ item }">
            <v-btn
              icon
              color="error"
              @click="jor18Delete(item.id_position, item.positions)"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>

          <template v-slot:no-results>
            <v-alert type="error" :value="true">
              ไม่พบผลลัพธ์ "{{ search }}" ที่คุณกำลังค้นหา
            </v-alert>
          </template>
        </v-data-table>
      </base-material-card>

      <!-- Add Dialog -->
      <v-dialog v-model="addjor18dialog" persistent max-width="600px">
        <v-card>
          <v-card-title class="primary white--text">
            <v-icon left color="white">mdi-account-multiple</v-icon>
            เพิ่มข้อมูลประเภทสถานศึกษา
          </v-card-title>

          <v-card-text class="pt-4">
            <v-form ref="addjor18form" v-model="valid" lazy-validation>
              <v-autocomplete
                v-model="addjor18.j18college_code"
                :items="colleges"
                item-text="college_name"
                item-value="college_code"
                label="วิทยาลัย"
                :rules="[v => !!v || 'กรุณาเลือกวิทยาลัย']"
                outlined
              />

              <v-text-field
                v-model="addjor18.id_position"
                label="เลขที่ตำแหน่ง"
                :rules="[v => !!v || 'กรุณาระบุเลขที่ตำแหน่ง']"
                outlined
              />

              <v-autocomplete
                v-model="addjor18.positions"
                :items="userstatus"
                item-text="user_status_name"
                item-value="user_status_name"
                label="ตำแหน่ง"
                :rules="[v => !!v || 'กรุณาเลือกตำแหน่ง']"
                outlined
              />
            </v-form>
          </v-card-text>

          <v-card-actions>
            <v-spacer />
            <v-btn color="grey" text @click="addjor18dialog = false">
              <v-icon left>mdi-close</v-icon>
              ยกเลิก
            </v-btn>
            <v-btn color="success" @click="addjor18Submit">
              <v-icon left>mdi-content-save</v-icon>
              บันทึก
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Edit Dialog -->
      <v-dialog v-model="editjor18dialog" persistent max-width="600px">
        <v-card>
          <v-card-title class="warning white--text">
            <v-icon left color="white">mdi-pencil</v-icon>
            แก้ไขข้อมูล
          </v-card-title>

          <v-card-text class="pt-4">
            <v-form ref="editjor18form" v-model="valid" lazy-validation>
              <div class="mb-4">
                เลขที่ตำแหน่ง: <strong>{{ editjor18.id_position }}</strong> | 
                ตำแหน่ง: <strong>{{ editjor18.positions }}</strong>
              </div>

              <v-autocomplete
                v-model="editjor18.j18college_code"
                :items="colleges"
                item-text="college_name"
                item-value="college_code"
                label="วิทยาลัย"
                :rules="[v => !!v || 'กรุณาเลือกวิทยาลัย']"
                outlined
              />

              <v-autocomplete
                v-model="editjor18.j18_reason"
                :items="reasons"
                item-text="text"
                item-value="value"
                label="เหตุผล"
                :rules="[v => !!v || 'กรุณาเลือกเหตุผล']"
                outlined
              />

              <v-textarea
                v-if="editjor18.j18_reason === 'etc'"
                v-model="editjor18.j18_reason_etc"
                label="เหตุผลอื่นๆ"
                :rules="[v => !!v || 'กรุณาระบุเหตุผลอื่นๆ']"
                outlined
              />
            </v-form>
          </v-card-text>

          <v-card-actions>
            <v-spacer />
            <v-btn color="grey" text @click="editjor18dialog = false">
              <v-icon left>mdi-close</v-icon>
              ยกเลิก
            </v-btn>
            <v-btn color="warning" @click="editjor18Submit">
              <v-icon left>mdi-pencil</v-icon>
              บันทึก
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Delete Dialog -->
      <v-dialog v-model="deletejor18dialog" persistent max-width="500px">
        <v-card>
          <v-card-title class="error white--text">
            <v-icon left color="white">mdi-delete</v-icon>
            ลบข้อมูลประเภทสถานศึกษา
          </v-card-title>

          <v-card-text class="pt-4">
            <v-alert type="warning" outlined>
              ยืนยันการลบข้อมูล<br>
              <strong>{{ editjor18.college_name }} : {{ editjor18.id_position }}</strong>
            </v-alert>
          </v-card-text>

          <v-card-actions>
            <v-spacer />
            <v-btn color="grey" text @click="deletejor18dialog = false">
              <v-icon left>mdi-close</v-icon>
              ยกเลิก
            </v-btn>
            <v-btn color="error" @click="deletejor18Submit">
              <v-icon left>mdi-delete</v-icon>
              ลบ
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- CSV Import Dialog -->
      <v-dialog v-model="man_powerCSVdialog" persistent max-width="600px">
        <v-card>
          <v-card-title class="success white--text">
            <v-icon left color="white">mdi-file-import</v-icon>
            นำเข้าข้อมูลอัตราสำรวจ
          </v-card-title>

          <v-card-text class="pt-4">
            <v-btn
              block
              large
              color="info"
              :to="`/admin/jo18_survey_import/`"
              target="_blank"
              class="mb-4"
            >
              <v-icon left>mdi-download</v-icon>
              ส่งออกแบบฟอร์มบันทึกข้อมูล
            </v-btn>

            <v-file-input
              v-model="file2"
              accept=".csv"
              label="ไฟล์ CSV อัตรากำลัง"
              prepend-icon="mdi-paperclip"
              outlined
              show-size
              counter
            />

            <v-btn
              block
              large
              color="success"
              @click="csvManpowerSubmit"
              :disabled="!file2"
            >
              <v-icon left>mdi-upload</v-icon>
              นำเข้าข้อมูล
            </v-btn>
          </v-card-text>

          <v-card-actions>
            <v-spacer />
            <v-btn icon large color="grey" @click="man_powerCSVdialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Snackbar -->
      <v-snackbar
        v-model="snackbar.show"
        :color="snackbar.color"
        :timeout="snackbar.timeout"
        top
      >
        <v-icon left>{{ snackbar.icon }}</v-icon>
        {{ snackbar.text }}
        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="snackbar.show = false">
            ปิด
          </v-btn>
        </template>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import jor_18bar from "../../components/admin/jor_18bar";

export default {
  components: { jor_18bar },

  data() {
    return {
      ApiKey: "HRvec2021",
      valid: true,
      loading: false,
      file2: null,

      // Dialogs
      addjor18dialog: false,
      editjor18dialog: false,
      deletejor18dialog: false,
      man_powerCSVdialog: false,

      // Snackbar
      snackbar: {
        show: false,
        color: "",
        timeout: 5000,
        icon: "",
        text: ""
      },

      // Data
      jor18s: [],
      colleges: [],
      userstatus: [],
      addjor18: {},
      editjor18: {},

      // Search
      search: "",
      collegesSelect: "",
      idPositionSelect: "",

      // Table
      headers: [],
      selectedHeaders: [],
      headersMap: [
        { text: "รหัสวิทยาลัย", value: "j18college_code" },
        { text: "สถานศึกษา", value: "college_name" },
        { text: "จังหวัด", value: "province_name" },
        { text: "ภาค", value: "region_name" },
        { text: "อัตราว่าง", value: "num_position" },
        { text: "ตำแหน่ง", value: "positions" },
        { text: "รหัสตำแหน่ง", value: "id_position" },
        { text: "จัดการ", value: "actionSelect" },
        { text: "นำมาใช้", value: "j18_reason" },
        { text: "สำรวจ", value: "j18_collegereport" },
        { text: "เหตุผลอื่น", value: "j18_reason_etc" },
        { text: "เหตุการณ์", value: "j18_background" },
        { text: "วิทยฐานะ", value: "rang_positon" },
        { text: "ID คนครอง", value: "id_card" },
        { text: "คนครอง", value: "titles" },
        { text: "แก้ไข", value: "actions" },
        { text: "ลบ", value: "action_s" }
      ],

      // Reasons
      reasons: [
        { text: "คัดเลือก", value: "คัดเลือก" },
        { text: "สอบแข่งขัน", value: "สอบแข่งขัน" },
        { text: "ย้าย", value: "ย้าย" },
        { text: "อื่นๆ", value: "etc" }
      ],

      // Edit
      editedIndex: -1,
      editedItem: {
        id_no: 0,
        j18_reason: ""
      },
      defaultItem: {
        id_no: 0,
        j18_reason: ""
      },

      data_syslog: {}
    };
  },

  computed: {
    showHeaders() {
      return this.headers.filter(h => this.selectedHeaders.includes(h));
    },

    date_today_log() {
      const today = new Date();
      const dd = String(today.getDate()).padStart(2, "0");
      const mm = String(today.getMonth() + 1).padStart(2, "0");
      const yyyy = today.getFullYear() + 543;
      const time = `${today.getHours()}:${today.getMinutes()}:${today.getSeconds()}`;
      return `${dd}/${mm}/${yyyy}/${time}`;
    }
  },

  async created() {
    this.headers = Object.values(this.headersMap);
    this.selectedHeaders = this.headers;
  },

  async mounted() {
    await this.initialize();
  },

  methods: {
    async initialize() {
      await this.showLoading();

      try {
        const [collegesRes, userStatusRes] = await Promise.all([
          this.$http.post("college.php", { ApiKey: this.ApiKey }),
          this.$http.post("crud_user_status.php?crud=read", { ApiKey: this.ApiKey })
        ]);

        this.colleges = collegesRes.data;
        this.userstatus = userStatusRes.data;

        await this.searchTeacher();
      } catch (error) {
        this.showError("เกิดข้อผิดพลาดในการโหลดข้อมูล");
      } finally {
        this.hideLoading();
      }
    },

    hasIdCard(item) {
      return String(item.id_card).length > 5;
    },

    async csvManpowerSubmit() {
      if (!this.file2) return;

      const formData = new FormData();
      formData.append("file", this.file2);
      formData.append("filename", "../HRvecfiles/jor18Survey.csv");
      formData.append("ApiKey", this.ApiKey);

      try {
        const result = await this.$http.post("jor18_csv_survey.php", formData, {
          headers: { "Content-Type": "multipart/form-data" }
        });

        if (result.data.status) {
          this.showSuccess("บันทึกข้อมูลเรียบร้อย");
          await this.searchTeacher();
        } else {
          this.showWarning("ดำเนินการผิดพลาด");
        }
      } catch (error) {
        this.showError("เกิดข้อผิดพลาดในการนำเข้าข้อมูล");
      } finally {
        this.man_powerCSVdialog = false;
        this.file2 = null;
      }
    },

    man_powerCSV() {
      this.man_powerCSVdialog = true;
    },

    editItem(item) {
      this.editedIndex = this.jor18s.indexOf(item);
      this.editedItem = Object.assign({}, item);
    },

    close() {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
    },

    async save() {
      try {
        this.editedItem.ApiKey = this.ApiKey;
        Object.assign(this.jor18s[this.editedIndex], this.editedItem);

        const result = await this.$http.post("jor18.updateIdno.php", this.editedItem);

        if (result.data.status) {
          this.showSuccess("บันทึกข้อมูลเรียบร้อย");
        } else {
          this.showWarning("ทำรายการซ้ำ");
        }
      } catch (error) {
        this.showError("เกิดข้อผิดพลาดในการบันทึก");
      } finally {
        this.close();
      }
    },

    async clearSurvey() {
      const confirmed = await this.confirmDialog(
        "ต้องการยกเลิกรายการสำรวจทั้งหมด?"
      );

      if (!confirmed) return;

      try {
        this.editedItem.ApiKey = this.ApiKey;
        const result = await this.$http.post(
          "jor18.updateclearSurvey.php",
          this.editedItem
        );

        if (result.data.status) {
          this.showSuccess("ดำเนินการเรียบร้อย");
          await this.searchTeacher();
        } else {
          this.showWarning("ผิดพลาด");
        }
      } catch (error) {
        this.showError("เกิดข้อผิดพลาด");
      }
    },

    async deleteItem(id_no) {
      const confirmed = await this.confirmDialog(
        "ต้องการยกเลิกรายการสำรวจนี้?"
      );

      if (!confirmed) return;

      try {
        const payload = {
          ApiKey: this.ApiKey,
          id_no: id_no,
          j18_reason: "",
          j18_collegereport: 0
        };

        const result = await this.$http.post("jor18.updateIdno.php", payload);

        if (result.data.status) {
          this.showSuccess("ดำเนินการเรียบร้อย");
          await this.searchTeacher();
        } else {
          this.showWarning("ผิดพลาด");
        }
      } catch (error) {
        this.showError("เกิดข้อผิดพลาด");
      }
    },

    async searchByPosition(position) {
      await this.showLoading();
      this.loading = true;

      try {
        const result = await this.$http.post("jor18.php", {
          ApiKey: this.ApiKey,
          positions: position,
          idpostion_null: "ok"
        });

        this.jor18s = result.data;
      } catch (error) {
        this.showError("เกิดข้อผิดพลาดในการค้นหา");
      } finally {
        this.loading = false;
        this.hideLoading();
      }
    },

    async searchTeacher() {
      await this.searchByPosition("ครู");
    },

    async searchSecDirector() {
      await this.searchByPosition("รองผู้อำนวยการวิทยาลัย");
    },

    async searchDirector() {
      await this.searchByPosition("ผู้อำนวยการวิทยาลัย");
    },

    async updatej18background() {
      try {
        this.updatemanpowers.ApiKey = this.ApiKey;
        const result = await this.$http.post(
          "man_power.insert.j18.php",
          this.updatemanpowers
        );

        if (result.data.status) {
          this.showSuccess("ปรับปรุงข้อมูลอัตรากำลังรับย้ายเรียบร้อย");
        }
      } catch (error) {
        this.showError("เกิดข้อผิดพลาดในการปรับปรุง");
      }
    },

    async SearchNull() {
      await this.showLoading();
      this.loading = true;

      try {
        const result = await this.$http.post("jor18.php", {
          ApiKey: this.ApiKey,
          idpostion_null: "ok"
        });

        this.jor18s = result.data;
      } catch (error) {
        this.showError("เกิดข้อผิดพลาดในการค้นหา");
      } finally {
        this.loading = false;
        this.hideLoading();
      }
    },

    clearSearch() {
      this.jor18s = [];
      this.collegesSelect = "";
      this.idPositionSelect = "";
      this.search = "";
    },

    async jor18sSearch() {
      if (!this.collegesSelect) return;

      this.loading = true;
      try {
        const result = await this.$http.post("jor18.php", {
          ApiKey: this.ApiKey,
          j18college_code: this.collegesSelect
        });

        this.jor18s = result.data;
      } catch (error) {
        this.showError("เกิดข้อผิดพลาดในการค้นหา");
      } finally {
        this.loading = false;
      }
    },

    async jor18sIDpostionSearch() {
      if (!this.idPositionSelect) return;

      this.loading = true;
      try {
        const result = await this.$http.post("jor18.php", {
          ApiKey: this.ApiKey,
          id_position: this.idPositionSelect
        });

        this.jor18s = result.data;
      } catch (error) {
        this.showError("เกิดข้อผิดพลาดในการค้นหา");
      } finally {
        this.loading = false;
      }
    },

    async jor18QueryAll() {
      this.loading = true;
      try {
        const result = await this.$http.post("jor18.php", {
          ApiKey: this.ApiKey
        });

        this.jor18s = result.data;
      } catch (error) {
        this.showError("เกิดข้อผิดพลาดในการโหลดข้อมูล");
      } finally {
        this.loading = false;
      }
    },

    jor18Add() {
      this.addjor18 = {};
      this.addjor18dialog = true;
    },

    async addjor18Submit() {
      if (!this.$refs.addjor18form.validate()) return;

      try {
        this.addjor18.ApiKey = this.ApiKey;
        this.addjor18.id_card = "";

        const result = await this.$http.post("jor18.insert.php", this.addjor18);

        if (result.data.status) {
          this.showSuccess("บันทึกข้อมูลเรียบร้อย");
          await this.logAction("insert", `${this.addjor18.id_position}:${this.addjor18.college_code}`);
          await this.jor18QueryAll();
        } else {
          this.showWarning("บันทึกข้อมูลผิดพลาด");
        }
      } catch (error) {
        this.showError("เกิดข้อผิดพลาดในการบันทึก");
      } finally {
        this.addjor18dialog = false;
      }
    },

    async jor18Edit(id_position, positions) {
      try {
        const result = await this.$http.post("jor18.php", {
          ApiKey: this.ApiKey,
          id_position: id_position,
          positions: positions
        });

        this.editjor18 = result.data;
        this.editjor18dialog = true;
      } catch (error) {
        this.showError("เกิดข้อผิดพลาดในการโหลดข้อมูล");
      }
    },

    async editjor18Submit() {
      if (!this.$refs.editjor18form.validate()) return;

      try {
        this.editjor18.ApiKey = this.ApiKey;
        const result = await this.$http.post(
          "jor18.updateIdPosition.php",
          this.editjor18
        );

        if (result.data.status) {
          this.showSuccess("แก้ไขข้อมูลเรียบร้อย");
          await this.logAction(
            "update",
            `${this.editjor18.id_position}:${this.editjor18.college_code}:${this.editjor18.case_vacancy}`
          );
          await this.jor18QueryAll();
        } else {
          this.showWarning("แก้ไขข้อมูลผิดพลาด");
        }
      } catch (error) {
        this.showError("เกิดข้อผิดพลาดในการแก้ไข");
      } finally {
        this.editjor18dialog = false;
      }
    },

    async jor18Delete(id_position, positions) {
      try {
        const result = await this.$http.post("jor18.php", {
          ApiKey: this.ApiKey,
          id_position: id_position,
          positions: positions
        });

        this.editjor18 = result.data;
        this.deletejor18dialog = true;
      } catch (error) {
        this.showError("เกิดข้อผิดพลาดในการโหลดข้อมูล");
      }
    },

    async deletejor18Submit() {
      if (!this.$refs.deletejor18form) return;

      try {
        this.editjor18.ApiKey = this.ApiKey;
        const result = await this.$http.post("jor18.delete.php", this.editjor18);

        if (result.data.status) {
          this.showSuccess("ลบข้อมูลเรียบร้อย");
          await this.logAction(
            "delete",
            `${this.editjor18.id_position}:${this.editjor18.college_code}:${this.editjor18.case_vacancy}`
          );
          await this.jor18QueryAll();
        } else {
          this.showWarning("ลบข้อมูลผิดพลาด");
        }
      } catch (error) {
        this.showError("เกิดข้อผิดพลาดในการลบ");
      } finally {
        this.deletejor18dialog = false;
      }
    },

    async logAction(event, detail) {
      try {
        const userSession = JSON.parse(sessionStorage.getItem("user")) || {};
        
        const logData = {
          ApiKey: this.ApiKey,
          user_account: userSession.user_name,
          event_log: event,
          page_log: "jor18",
          table_log: "jor18",
          detail_log: detail,
          date_times: this.date_today_log
        };

        await this.$http.post("data_syslog.insert.php", logData);
      } catch (error) {
        console.error("Failed to log action:", error);
      }
    },

    async showLoading() {
      Swal.fire({
        title: "กรุณารอสักครู่...",
        html: "กำลังโหลดข้อมูล",
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });
    },

    hideLoading() {
      Swal.close();
    },

    showSuccess(message) {
      Swal.fire({
        icon: "success",
        title: message,
        showConfirmButton: false,
        timer: 1500
      });
    },

    showWarning(message) {
      Swal.fire({
        icon: "warning",
        title: message,
        showConfirmButton: false,
        timer: 1500
      });
    },

    showError(message) {
      Swal.fire({
        icon: "error",
        title: message,
        showConfirmButton: false,
        timer: 2000
      });
    },

    async confirmDialog(message) {
      const result = await Swal.fire({
        title: message,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก"
      });

      return result.isConfirmed;
    }
  }
};
</script>

<style scoped>
.v-data-table {
  font-size: 14px;
}

.v-chip {
  font-size: 12px;
}
</style>